import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {NumberUtil} from "base/utilities";

import {EntityViewPanel} from "base/entity";
import {SectionCard, SectionField} from "base/component/presentational";

import Box from "@mui/material/Box";
import {ZoningareasService} from "./ZoningareasService";

export const ZoningareasViewPanel = () => {
    const {id} = useParams();

    const [entityState, setEntityState] = useState(null);

    useEffect(() => {
        ZoningareasService.get(id).then(data => {
            setEntityState(data);
        });
    }, [id]);

    return (
        entityState && (
            <EntityViewPanel title="Zoning Areas" showDetailButton={false}>
                <SectionCard title={`${entityState.id}`}>
                    <SectionField
                        label="Official Source:"
                        value={entityState.offsource}
                    />
                    <SectionField label="MS:" value={entityState.ms} />
                    <SectionField
                        label="Hilucs Land Use:"
                        value={entityState.hiluclu}
                    />
                    <SectionField label="Hilucs MSP:" value={entityState.hilucsmsp} />
                    <SectionField
                        label="Sea Use Name:"
                        value={entityState.seausename}
                    />
                    <SectionField
                        label="Sea Use Function:"
                        value={entityState.seausefct}
                    />
                    <SectionField
                        label="Sea Use Description:"
                        value={entityState.seausedsc}
                    />
                    <SectionField
                        label="Origin Use Name:"
                        value={entityState.originun}
                    />
                    <SectionField
                        label="Origin Use Name EN:"
                        value={entityState.originunen}
                    />
                </SectionCard>
            </EntityViewPanel>
        )
    );
};
